import Link from 'next/link';

import { BodyRegular } from '@common/body';
import Button from '@common/Button/Button';
import { H3 } from '@common/headline';
import RightArrow from '@common/Icons/RightArrow';
import { TextLinkS } from '@common/textLink';

type Props = {
  backgroundColour: string;
  buttonColour: 'NavyBlue' | 'Teal' | 'White';
  categoryTitle: string;
  categoryTitleColour: string;
  children: React.ReactNode;
  cta: string;
  ctaColour: string;
  description?: string;
  descriptionColour?: string;
  href: string;
};

export const RecipesAndGuidesContainer = ({
  backgroundColour,
  buttonColour,
  categoryTitle,
  categoryTitleColour,
  children,
  cta,
  ctaColour,
  description,
  descriptionColour,
  href,
}: Props): JSX.Element => (
  <div
    className={`${backgroundColour} ${categoryTitleColour} px-3 pt-[68px] md:px-[40px] md:py-20 lg:px-[60px]`}
  >
    <div className="container m-auto">
      <div className="mb-8 flex items-center justify-between text-center lg:mb-6">
        <H3>{categoryTitle}</H3>
        <div className={`flex ${ctaColour} items-center`}>
          <div className="mr-6 hidden md:block">
            <TextLinkS url={href}>{cta}</TextLinkS>
          </div>
          <Link href={href}>
            <Button
              colour={buttonColour}
              type="Secondary"
              icon={<RightArrow />}
            />
          </Link>
        </div>
      </div>
      {description && (
        <div className={`${descriptionColour} mb-8 lg:mb-10 lg:w-1/2`}>
          <BodyRegular>{description}</BodyRegular>
        </div>
      )}
      {children}
    </div>
  </div>
);
